import { leaks } from '@/mocks/chigua';

const levelStyle: Record<string, string> = {
  高可信: 'bg-emerald-600 text-paper-50',
  中可信: 'bg-ocher-300 text-ink-800',
  待核验: 'bg-ink-300 text-ink-900',
};

export default function Leaks() {
  return (
    <section id="leaks" className="scroll-mt-16 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="font-heading text-sm font-bold tracking-widest text-accent-700">知情者爆料 · 分级合集</span>
              <span className="h-px w-8 bg-accent-400" />
            </div>
            <h2 className="mt-2 font-heading text-2xl font-bold text-ink-900 md:text-3xl">
              同一件事，放在一起看才见真章
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-ink-500">
            每条爆料均标注可信度与来源方式，高可信与待核验分开陈列，绝不混为一谈。
          </p>
        </div>

        <div className="mt-8 overflow-hidden rounded-lg border border-paper-200 bg-paper-50">
          <div className="grid grid-cols-[auto_1fr_auto] items-center gap-3 border-b border-paper-200 bg-paper-100 px-4 py-2.5 text-xs font-semibold text-ink-500 md:grid-cols-[70px_130px_1fr_auto]">
            <span>编号</span>
            <span className="hidden md:block">可信度 / 信源</span>
            <span>内容要点</span>
            <span className="hidden md:block">佐证情况</span>
          </div>
          <ul className="divide-y divide-paper-200">
            {leaks.map((l) => (
              <li
                key={l.code}
                className="grid grid-cols-[auto_1fr_auto] items-center gap-3 px-4 py-4 transition-colors hover:bg-paper-100/60 md:grid-cols-[70px_130px_1fr_auto]"
              >
                <span className="font-heading text-sm font-bold text-accent-600">{l.code}</span>
                <span className="hidden md:block">
                  <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${levelStyle[l.level]}`}>
                    {l.level}
                  </span>
                  <span className="ml-2 text-xs text-ink-500">{l.tag}</span>
                </span>
                <p className="text-[13px] leading-[1.7] text-ink-800 md:text-sm">「{l.quote}」</p>
                <span className="hidden max-w-[200px] text-right text-[12px] leading-relaxed text-ink-400 md:block">
                  {l.meta}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-4 flex flex-col gap-2 text-xs text-ink-500 sm:flex-row sm:items-center sm:justify-between">
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line text-sm text-accent-500" />
            移动端已折叠「可信度与佐证」，完整信息见桌面浏览。
          </p>
          <span>共收录 {leaks.length} 条，另有 {leaks.length} 条因证据不足暂未上架。</span>
        </div>
      </div>
    </section>
  );
}